
const SSta = require('simple-statistics');
export default {
  data () {
    return {
      
    }
  },
  computed: {
    SH_flag () {
      return this.SH_use
    },
    EventsList () {
      let evlist = ['SING', 'SEC', 'THI', 'HR', 'BB', 'HBP', 'SO', 'OUT']
      //if(this.SH_flag)evlist.push('SH')
      return evlist
    },
    PosList () {
      return ['投', '捕', '一', '二', '三', '遊', '外', '指']
    },
    InputHandList () {
      const hand = {
        b: ['右打', '左打', '両打'],
        p: ['右投', '左投', '両投']
      }
      return hand[this.PBcheck]
    },
    Setubi (r) {
      const s = { heig: 'cm', weig: 'kg' }
      if (s[r] === undefined) {
        return ''
      } else {
        return s[r]
      }
    },
    CateList () {
      return ['リーグ', '球団', '選手']
    },
    calcWari () {
      return function (a, b) {
        const bunsi = Number(a)
        const bunbo = Number(b)
        if (isNaN(bunsi) || isNaN(bunbo)) return 0
        if (bunbo === 0 && bunsi === 0) return 0
        if (bunbo === 0 && bunsi > 0) return 99999
        return bunsi / bunbo
      }
    },
    PrintRecordList () {
        return ['AB', 'AVG', 'OBP', 'SLG', 'OPS']
    },
    RecordName () {
      const recname = {
        t:[
          ['G', '試合'],
          ['W', '勝利'],
          ['L', '敗戦'],
          ['D', '引分'],
          ['WR', '勝率'],
          ['year', '年度'],
          ['PWR', 'ピタゴラス勝率'],
        ],
        /*
        padv:['FIP', 'LOB', 'KBB', 'KBBp'],
        badv:['RC', 'XR', 'IsoP', 'IsoD', 'wOBA'],*/
        p:[
          ['G', '登板'],
          ['GS', '先発'],
          ['CG', '完投'],
          ['ShO', '完封'],
          ['W', '勝利'],
          ['L', '敗戦'],
          ['IP', '投球回'],
          ['FG', '無四球'],
          ['ER', '自責'],
          ['ERA', '防御率'],
          ['WR', '勝率'],
          ['SV', 'セーブ'],
          ['HLD', 'ホールド'],
          ['TBF', '打者'],
          ['HBP', '与死球'],
          ['AB', '打数'],
          ['R', '失点'],
          ['H', '被安打'],
          ['HR', '被本'],
          ['BB', '与四球'],
          ['SO', '奪三振'],
          ['WP', '暴投'],
          ['BK', 'ボーク'],
          ['RA', '失点率'],
          ['SOp', 'SO%'],
          ['BBp', 'BB%'],
          ['HRp', 'HR%'],
          ['AVG', '被打率'],
          ['Kn', 'K/9'],
          ['BBn', 'BB/9'],
          ['HRn', 'HR/9'],
          ['LOB', 'LOB%'],
          ['KBB', 'K/BB'],
          ['KBBp', 'K-BB'],
        ],
        b:[
          ['G', '出場'],
          ['PA', '打席'],
          ['AB', '打数'],
          ['R', '得点'],
          ['H', '安打'],
          ['SING', '単打'],
          ['SEC', '二塁'],
          ['THI', '三塁'],
          ['HR', '本塁'],
          ['RBI', '打点'],
          ['BB', '四球'],
          ['IBB', '敬遠四球'],
          ['HBP', '死球'],
          ['SO', '三振'],
          ['SB', '盗塁'],
          ['TB', '塁打数'],
          ['GDP', '併殺'],
          ['SF', '犠飛'],
          ['CS', '盗死'],
          ['SH', '犠打'],
          ['AVG', '打率'],
          ['OBP', '出塁率'],
          ['SLG', '長打率'],
          ['BT', '塁打数'],
          ['SOp', 'SO%'],
          ['BBp', 'BB%'],
          ['HRp', 'HR%'],
          ['RCAA', 'RC+'],
          ['XRAA', 'XR+'],
          ['BBK', 'BB/K'],
          ['KBBp', 'K-BB'],
        ],
      }
      return function (pb, r, exf) {
        let name = null;
        recname[pb].some(p => {
         if(p[exf] == r){
           name = p[exf^1]
           return true
         }
        })
        if(name)return name;
        return r
      }
    },
    printAVG () {
      const zero = '0000000'
      return function (avg, conm) {
        if (isNaN(avg)) return '.'
        const avgnum = Number(avg)
        var str = String(Math.round(avgnum * Math.pow(10, conm)))
        const zflag = (conm === 3)
        if (avgnum === 0) str = '0'
        while(str.length < 3) str = '0' + str
        function strIns(str, idx, val){
          const to_str = str.slice()
          return to_str.slice(0, idx) + val + to_str.slice(idx);
        };
        if(str.length > 3) {
          return strIns(str, str.length - 3, '.')
        }else{
          return '.' + str
        }
        //if (avgnum < 1.00 && zflag)str = str.slice(1)
        //if (str.indexOf('.') === -1 && str.length <= conm)str += '.'
        //if (conm - zflag - str.length + 2 > 0)str += zero.slice(0, conm - zflag - str.length + 2)
        
      }
    },
    printDEF () {
      return function (def) {
        let posstr = ''
        this.PosList.some(pos => {
          if (def.indexOf(pos) > -1)posstr += pos
        })
        return posstr
      }
    },
    CheckStamem() {
      return function(t, nen) {
        const team = this.teamID(t)
        return (team in StarterData && Number(nen) in StarterData[team]);
      }
    },
  },
  methods: {
    ZeroEx (para) {
      if (para === undefined || para === '') return 0
      return Number(para)
    },
    calcERA(r, ra=false){
      const er = (ra ? r.R : r.ER)
      return this.calcWari(er * 9 * 3, r.IPa * 3 + r.IPb)
    },
    calcFIP(r, hosei=2.85){
      return (this.calcWari((13 * r.HR + 3 * (r.BB - 0 + r.HBP) - 2 * r.SO) * 3 , r.IPa * 3 + r.IPb) + hosei)
    },
    CalcFIPHosei(rdata) {
      return this.calcERA(rdata) - this.calcFIP(rdata, 0)
    },
    Ining (r) {
      return r.IPa + this.calcWari(r.IPb, 3)
    },
    calcRecord (rname, r, gw_p = 1.00, lgr = null) {
      
      switch (rname) {
        case 'ERA':
          return this.calcERA(r).toFixed(4)
        case 'RA':
          return this.calcERA(r, true).toFixed(4)
        case 'FIP':
          return this.calcFIP(r, this.CalcFIPHosei(lgr)).toFixed(4)
        case 'PA':
          return this.calcWari(r.PA != undefined ? r.PA : r.TBF, gw_p)
        case 'SOp':
          return this.calcWari(r.SO, this.calcRecord('PA', r, 1)).toFixed(4)
        case 'HRp':
          return this.calcWari(r.HR, this.calcRecord('PA', r, 1)).toFixed(4)
        case 'BBp':
          return this.calcWari(r.BB, this.calcRecord('PA', r, 1)).toFixed(4)
        case 'HBPp':
          return this.calcWari(r.HBP, this.calcRecord('PA', r, 1)).toFixed(4)
        case 'OBP':
          return this.calcWari(r.H + r.BB + r.HBP, r.AB + r.BB + r.HBP + r.SF).toFixed(4)
        case 'IsoP':
          return (this.calcWari(r.TB - r.H, r.AB)).toFixed(4)
        case 'IsoD':
          return (
            this.calcWari(r.H + r.BB + r.HBP, r.AB + r.BB + r.HBP + r.SF) - this.calcWari(r.H, r.AB)
          ).toFixed(4)
        case 'SLG':
          return this.calcWari(this.calcRecord('TB', r, 1), r.AB).toFixed(4)
        case 'AVG':
          return this.calcWari(this.calcRecord('H', r, 1), this.calcRecord('AB', r, 1)).toFixed(4)
        case 'OPS':
          return (this.calcWari(this.calcRecord('TB', r, 1), r.AB)
          + this.calcWari(r.H + r.BB + r.HBP, r.AB + r.BB + r.HBP + r.SF)).toFixed(4)
        case 'IP':{
          return this.calcWari(r.IPa + this.calcWari(r.IPb, 3), gw_p).toFixed(4)
        }
        case 'WR':
          return this.calcWari(r.W, r.W + r.L).toFixed(4);
        case 'BABIP':
          return this.calcWari(r.H - r.HR, r.AB - r.SO - r.HR).toFixed(4)
        case 'WHIP':
          return this.calcWari(r.H + r.BB, this.Ining(r)).toFixed(4)
        case 'Kn':
          return this.calcWari(r.SO * 9, this.Ining(r)).toFixed(4)
        case 'BBn':
          return this.calcWari(r.BB * 9, this.Ining(r)).toFixed(4)
        case 'HRn':
          return this.calcWari(r.HR * 9, this.Ining(r)).toFixed(4)
        case 'LOB':
          return this.calcWari(r.H + r.BB + r.HBP - r.R, r.H + r.BB + r.HBP - r.HR * 1.4).toFixed(4)
        case 'KBB':
          return this.calcWari(r.SO, r.BB).toFixed(4)
        case 'Speed':{
          let ss = [];
          ss.push((this.calcWari(r.SB + 3, r.SB + r.CS + 7) - 0.4) * 20);
          ss.push(Math.sqrt(this.calcWari(r.SB + r.CS, r.SING + r.BB + r.HBP))*14.28571);
          ss.push(this.calcWari(r.THI, r.AB - r.HR - r.SO) * 500);
          ss.push((this.calcWari(r.R - r.HR, r.H + r.BB + r.HBP - r.HR) - 0.1) * 25);
          let total = 0
          ss.some(s=> {
            total += Math.max(Math.min(s, 10), 0)
          })
          return this.calcWari(total, ss.length).toFixed(4)
        }
        case 'BBK':
          return this.calcWari(r.BB, r.SO).toFixed(4)
        case 'KBBp':
          return this.calcWari(r.SO - r.BB, this.calcRecord('PA', r, 1)).toFixed(4)
        case 'RC':{
          const A = r.H + r.BB + r.HBP - r.CS - r.GDP
          const B = r.TB + 0.26 * (r.BB + r.HBP) + 0.53 * (r.SF + r.SH) + 0.64 * r.SB - 0.03 * r.SO
          const C = r.AB + r.BB + r.HBP + r.SF + r.SH
          return this.calcWari(this.calcWari((A + 2.4 * C) * (B + 3 * C), 9 * C) - 0.9 * C, gw_p).toFixed(4)
        }
        case 'RCAA':{
          return Number(this.calcRecord('RC', r, 1)) - this.calcWari(Number(this.calcRecord('RC', lgr, 1)), lgr.PA) * r.PA
        }
        case 'XR':{
          return this.calcWari(r.SING*0.498 + r.SEC * 0.760 + r.THI * 1.000 + r.HR * 1.446 + (r.BB + r.HBP - r.IBB)*0.332
　　　　　+ r.IBB * 0.167 + r.SF * 0.505 + r.SB * 0.202 + r.CS *(-0.482) + (r.AB - r.H) *(-0.105)
　　　　　+ r.GDP *(-0.374), gw_p).toFixed(4)
        }
        case 'wOBA':
          return (0.69*(r.BB-r.IBB) + 0.73 * r.HBP + 0.87 * r.SING + 1.29 * r.SEC + 1.74 * r.THI + 2.07 * r.HR) / (r.AB + r.BB - r.IBB + r.SF + r.HBP)
        case 'wRAA':
          return this.calcWari(this.calcRecord('wOBA', r, 1) - this.calcRecord('wOBA', lgr, 1), 1.15) * r.PA
        case 'wRC':{
          return this.calcRecord('wRAA', r, 1, lgr) + this.calcWari(lgr.R, lgr.PA) * r.PA
        }
        case 'year':
          return Number(r.nen.replace(/[^0-9]/g, ''));
        default:
          {
            const nen_num = Number(r["nen"].replace(/[^0-9]/g, ''))
            if(nen_num <= 2004 && rname == "HLD" || nen_num <= 1973 && rname == "SV" ||
              nen_num <= 1954 && rname == "IBB" || nen_num <= 1953 && rname == "SF")return null
            
            return r[rname]!=undefined ? this.calcWari(r[rname], gw_p).toFixed(4) : null
          }
      }//TB 塁打数
    },
    RandNameSet () {
      const rec = (this.PBcheck === 'p' ? 'IPa' : 'H')
      const hundred = this.users.filter(p =>
        (Number(p.nen) > 1960) && (p[rec] >= (50))
      )
      var player = hundred[parseInt(Math.random() * (hundred.length - 1))]
      this.setID(player.id, player.nen)
      return 1
    },
    nameSlice (str) {
      return {name: str, year: '0'}
      const target = str.indexOf('/')
      if (target < 0) return {name: str, year: '0'}
      return {name: str.substring(0, target), year: str.substring(target + 1)}
    },
    setRecord (p) {
      let record = this.EmptyPlayer(0)
      Object.keys(p).some((rec) => {
        record[rec] = p[rec]
      })
      if(p['SF'])record['AB'] += p['SF']
      record['name'] = p['name']
      return record
    },
    parseBoolean(str) {
      // 文字列を判定
      if(typeof (str) == "string" || str instanceof String)return (str == 'true' || str == '1') ? true : false;
      return Boolean(str)
    },
    team_Color (team) {
      const main_n = 0.70,sub_n = 1.00
      switch(this.teamID(team, 1)) {
        case 0:
          return ['rgba(210, 126, 70, ' + main_n + ')', 'rgba(71, 71, 76, ' + sub_n + ')'];
        case 1:
          return ['rgba(144, 185, 197, ' + main_n + ')', 'rgba(85, 102, 186, ' + sub_n + ')'];
        case 2:
          return ['rgba(222, 222, 45, ' + main_n + ')', 'rgba(66, 66, 66, ' + sub_n + ')'];
        case 3:
          return ['rgba(40, 143, 178, ' + main_n + ')', 'rgba(16, 40, 88, ' + sub_n + ')'];
        case 4:
          return ['rgba(226, 16, 27, ' + main_n + ')', 'rgba(140, 10, 18, ' + sub_n + ')'];
        case 5:
          return ['rgba(68, 84, 172, ' + main_n + ')', 'rgba(190, 71, 71, ' + sub_n + ')'];
        case 6:
          return ['rgba(139, 133, 44, ' + main_n + ')', 'rgba(65, 65, 91, ' + sub_n + ')'];
        case 7:
          return ['rgba(210, 175, 53, ' + main_n + ')', 'rgba(72, 72, 72, ' + sub_n + ')'];
        case 8:
          return ['rgba(70, 184, 177, ' + main_n + ')', 'rgba(74, 74, 74, ' + sub_n + ')'];
        case 9:
          return ['rgba(108, 108, 108, ' + main_n + ')', 'rgba(45, 45, 45, ' + sub_n + ')'];
        case 10:
          return ['rgba(47, 66, 107, ' + main_n + ')', 'rgba(26, 36, 60, ' + sub_n + ')'];
        case 11:
          return ['rgba(167, 53, 90, ' + main_n + ')', 'rgba(158, 139, 54, ' + sub_n + ')'];
        case 12:
          return ['rgba(205, 44, 65, ' + main_n + ')', 'rgba(44, 57, 74, ' + sub_n + ')'];
          
        case 13://ロビンス
          return ['rgba(228, 48, 24, ' + main_n + ')', 'rgba(40, 57, 54, ' + sub_n + ')'];
        case 14:
          return ['rgba(181, 191, 221, ' + main_n + ')', 'rgba(56, 57, 56, ' + sub_n + ')'];
        case 15:
          return ['rgba(144, 63, 60, ' + main_n + ')', 'rgba(55, 70, 103, ' + sub_n + ')'];
          
        case 16:
          return ['rgba(6, 51, 143, ' + main_n + ')', 'rgba(226, 182, 15, ' + sub_n + ')'];
        case 17:
          return ['rgba(54, 55, 60, ' + main_n + ')', 'rgba(226, 182, 15, ' + sub_n + ')'];
        case 18:case 19:
          return ['rgba(20, 20, 66, ' + main_n + ')', 'rgba(216, 216, 216, ' + sub_n + ')'];
      }
      return ['rgba(231, 231, 231, ' + main_n + ')', 'rgba(55, 55, 55, ' + sub_n + ')'];
    },
    teamID (nm, numflag = 0) {
      const name = (nm.indexOf("/") > -1 ? nm.split('/')[1] : nm)
      const teamset = {// 福岡ソフトバンク→ソフトバンク 北海道日本ハム→日本ハム
        '巨人': ['読売ジャイアンツ', '東京巨人軍'],
        "横浜DeNA": ['DeNAベイスターズ', '横浜ベイスターズ', "大洋ホエールズ", "洋松ロビンス"],
        '阪神': ['阪神タイガース', '大阪タイガース', "タイガース"],
        "中日": ['名古屋ドラゴンズ', '中部日本', '中日ドラゴンズ', '産業'],
        "広島東洋": ["広島カープ", "広島"],
        "東京ヤクルト": ["ヤクルトアトムズ", "ヤクルトスワローズ", "サンケイスワローズ", "国鉄スワローズ", "アトムズ", "サンケイアトムズ"],

        "オリックス": ["阪急", "阪急ブレーブス", 'オリックスバファローズ', 'オリックスブルーウェーブ', 'オリックスブレーブス'],
        "ソフトバンク": ["ソフトバンクホークス", "ダイエーホークス", "南海ホークス", "南海", "近畿日本", "グレートリング", "福岡ソフトバンク"],
        "日本ハム": ['セネタース', "急映フライヤーズ", "東映フライヤーズ", "東急フライヤーズ", "日拓フライヤーズ", "日本ハムファイターズ", "北海道日本ハム"],
        "千葉ロッテ": ["ロッテオリオンズ", "大毎オリオンズ", "東京オリオンズ", "毎日オリオンズ", "ロッテマリーンズ"],
        "埼玉西武": ["クラウンライオンズ", "西鉄ライオンズ", "西武ライオンズ", "太平洋ライオンズ", "西鉄クリッパース"],
        "東北楽天": ["楽天イーグルス", "東北楽天"],
        
        "近鉄": ["近鉄パールス", "近鉄バファロー", "近鉄バファローズ", "近鉄"],
        "松竹ロビンス": ["大東京", "ライオン", "朝日", "パシフィック", '太陽ロビンス', "大陽ロビンス", "松竹ロビンス"],
        "イーグルス": ["イーグルス", "黒鷲", "大和"],
        "東京セネタース": ["東京セネタース", "翼", "大洋", "西鉄"],
        "金鯱": ["金鯱", "名古屋"],
        "トンボユニオンズ": ["高橋ユニオンズ", "トンボユニオンズ"],
        "西日本パイレーツ": ["西日本パイレーツ"],
        "大映ユニオンズ": ["ゴールドスター", "金星スターズ", "大映スターズ", "大映ユニオンズ"],
        "1リーグ": ["1リ", "1リーグ"],
        "セ・リーグ": ["セ"],
        "パ・リーグ": ["パ"],
      }
      const teamset_list = Object.keys(teamset)
      for(let ts = 0;ts < teamset_list.length; ts=ts+1){
        if(name == teamset_list[ts])return (numflag ? ts:teamset_list[ts]);
        const teams_list = Object.values(teamset[teamset_list[ts]])
        for(let t = 0;t < teams_list.length; t=t+1){
          if(name == teams_list[t])return (numflag ? ts :teamset_list[ts]);
        }
      }
      return null
    },
    CpyPlayer (jun, user) {
      let ls = this.LineUp.slice()
      if(jun == -1) {
        if(ls.length < 20){
          ls.push(this.setRecord(user))
          ls[ls.length - 1].jun = ls.length - 1
        }
      }else
      for(let j = 0; j<9; j=j+1){
        if(j >= (jun >= 9 ? 0 : jun) && j < (jun >= 9 ? 9 : jun + 1)){
          if(ls[j].lock == false)ls[j] = this.setRecord(user)
        }
        ls[j].jun = j
      }
      this.$store.commit('updateValue', {vals: ls, keyname: 'LineUp'})
    },
    useDH (t, nen) {
      const teamid = this.teamID(t)
      return (
        (teamid == 'オリックス' ||
        teamid == 'ソフトバンク' ||
        teamid == '日本ハム' ||
        teamid == '千葉ロッテ' ||
        teamid == '埼玉西武' ||
        teamid == '東北楽天' ||
        teamid == '近鉄'
        ) && Number(nen) >= 1975
      )
    },
    Leag(teamname, nen){
      const t = (teamname.indexOf("/") > -1 ? teamname.split('/')[1] : teamname);
      const n = nen.replace(/[^0-9]/g, '');
      if(Number(n) <1950 || t=='1リーグ')return '1リーグ';
      const id = this.teamID(t, 1)
      if(id < 6 || t == 13 || t == 18 || t == 'セ・リーグ')return 'セ・リーグ';
      return 'パ・リーグ';
    },
    ObjectListSort (obj, syoko, param, syoko2 = -1, param2 = "") {
      return obj.sort(function(a,b) {
        if(a[param]>b[param]) return (syoko ? -1 : 1);
        if(a[param]<b[param]) return (syoko ? 1 : -1);
        if(syoko2 > -1) {
          if(a[param2]>b[param2]) return (syoko2 ? -1 : 1);
          if(a[param2]<b[param2]) return (syoko2 ? 1 : -1);
        }
        return 0;
      });
    },
    uuid(e) {
      if (e.uid) return e.uid;

      const key = Math.random()
        .toString(16)
        .slice(2);

      this.$set(e, "uid", key);
      
      return e.uid;
    },
    print(a) {
      console.log(a)
      return '[0]'
    },
    hankaku2Zenkaku(str) {
      if(typeof (str) != "string"){
          console.log(str)
      }
      let newstr = str.replace(/[Ａ-Ｚａ-ｚ０-９．]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      newstr = newstr.replace(/　/g, " ").replace(/\n/g,"");//replace("?", "")
      return newstr
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utility.js